import { render, staticRenderFns } from "./ass-items.vue?vue&type=template&id=5b47aab7"
import script from "./ass-items.vue?vue&type=script&lang=js"
export * from "./ass-items.vue?vue&type=script&lang=js"
import style0 from "./ass-items.vue?vue&type=style&index=0&id=5b47aab7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports